import { render, staticRenderFns } from "./UnsupportedBanksDecisionPopup.vue?vue&type=template&id=1c40986a&"
import script from "./UnsupportedBanksDecisionPopup.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBanksDecisionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports